import i18n from '@/i18n'

interface ValidateAccountError {
    cdekClientIdErr: string|null;
    cdekClientSecretErr: string|null;
}

function validateAccount(cdekClientId: string|null, cdekClientSecret: string|null): ValidateAccountError {
    const errors: ValidateAccountError = {
        cdekClientIdErr: null,
        cdekClientSecretErr: null
    }

    if (!cdekClientId) {
        errors.cdekClientIdErr = i18n.t(
            'installer.createAccount.emptyField',
            { fieldName: i18n.t('installer.createAccount.cdekClientId').toString() }
        ).toString()
    }

    if (!cdekClientSecret) {
        errors.cdekClientSecretErr = i18n.t(
            'installer.createAccount.emptyField',
            { fieldName: i18n.t('installer.createAccount.cdekClientSecret').toString() }
        ).toString()
    }

    return errors
}

function isExistValidateError(errors: ValidateAccountError) {
    for (const key of Object.keys(errors)) {
        if (errors[key]) {
            return true
        }
    }

    return false
}

export { isExistValidateError, validateAccount, ValidateAccountError }
